import store from '../cache/store'

export default {
  methods: {
    showSuccess (msg) {
      this.showSnackbar('success', msg)
    },
    showError (msg) {
      this.showSnackbar('error', msg)
    },
    showSnackbar (color, msg) {
      store.commit('showSnackbar', {
        message: msg,
        color: color
      })
    }
  }
}
